// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__3fnJL","container":"styles_container__1hwTJ","buttonsContainer":"styles_buttonsContainer__3kcDp"};